import axios from 'axios';

export const tokenRetrievalRequest = () => {
  let baseUrl = process.env.REACT_APP_PUBLIC_DOMAIN;

  if (
    ![
      process.env.REACT_APP_QUESTIONNAIRE_DOMAIN,
      process.env.REACT_APP_PREVIEW_DOMAIN,
    ].includes(window.location.hostname)
  ) {
    baseUrl = process.env.REACT_APP_WHITE_LABEL_PUBLIC_DOMAIN;
  }

  return axios.get(`${baseUrl}/sanctum/csrf-cookie`, {
    withCredentials: true,
  });
};

export const getImage = (path) => {
  return `${process.env.REACT_APP_PUBLIC_IMAGES_S3}/${path}`;
};
